export const domainNameRegExp = /^(?:https?:\/\/)?([^:\\/\n]+)/gm;
export const protocolNameRegExp = /^(?:https?:\/\/)/gm;
export const passwordRegex =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[~`!@#$%^&*()_\-+={[}\]|:;"'<,>.?/]).{8,32}$/;

export const rfcRegEx = /^[0-9A-Za-z]+$/;
